import { useEffect, useRef } from 'react';

// Při přechodu mezi URL ve shellech (seznam → detail → zpět na seznam)
// pamatuje si scroll pozici původní URL a při návratu ji obnoví;
// u nových URL skroluje na vrchol.
export function useScrollRestore(key: string): void {
  const positions = useRef<Map<string, number>>(new Map());
  const prevKey = useRef<string | null>(null);

  useEffect(() => {
    const current = typeof window !== 'undefined'
      ? window.location.pathname + window.location.search
      : key;
    const previous = prevKey.current;

    if (previous != null && previous !== current) {
      positions.current.set(previous, window.scrollY);
    }

    if (previous !== current) {
      const saved = positions.current.get(current);
      // Čekáme na commit layoutu nové stránky, jinak by scrollTo spadlo na 0,
      // protože nový obsah ještě nedosahuje původní výšky dokumentu.
      requestAnimationFrame(() => {
        window.scrollTo({ top: saved ?? 0, left: 0, behavior: 'auto' });
      });
    }

    prevKey.current = current;
  }, [key]);
}
